import { DATE_FORMAT_dd_MMM_YYYY } from "constants/DateConstant";
import { split } from "lodash";
const { default: i18n } = require("lang");

export const companyLabels = () => [
  i18n.t("Company_PhoneNo"),
  i18n.t("Company_Email"),
  i18n.t("Company_Website"),
  i18n.t("Company_Description"),
  i18n.t("Company_Address"),
  i18n.t("Company_Contact"),
];
export const factoryLabels = () => [
  i18n.t("Description"),
  i18n.t("MillingLine"),
  i18n.t("Capacity"),
  i18n.t("Start_Date"),
  i18n.t("Factory_Location"),
];
const cmeLabelsAndKeys = () => [
    {label: i18n.t("MillName"), dataIndex: "assemblyName"},
    {label: i18n.t("MillDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: `${i18n.t("MillTorque")} (KNm)`, dataIndex: "colour"},
    {label: i18n.t("MillSize"), dataIndex: "assemblySize"},
    {label: `${i18n.t("Pitch")} (mm)`, dataIndex: "otherInformation"},
    {label: `${i18n.t("MillingCapacity")} (TCD)`, dataIndex: "caneCapacity"},
    {label: i18n.t("RollerNo"), dataIndex: "hammersNo"},
    {label: i18n.t("MillRPM"), dataIndex: "assemblyRPM"},
    {label: `${i18n.t("MillInstalledPower")} (kW)`, dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("MillManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("MillMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("MillInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const cpeLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: i18n.t("AssemblySize"), dataIndex: "assemblySize"},
    {label: `${i18n.t("CaneCapacity")} (${i18n.t("TCD")})`, dataIndex: "caneCapacity"},
    {label: i18n.t("HammersNo"), dataIndex: "hammersNo"},
    {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
    {label: `${i18n.t("AssemblyInstalledPower")} (kW)`, dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const cceLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: `${i18n.t("AssemblySize")} (${i18n.t("Width")} x ${i18n.t("Length")} x ${i18n.t("Depth")})`, dataIndex: "assemblySize"},
    {label: `${i18n.t("DesignCapacity")} (${i18n.t("TCD")})`, dataIndex: "caneCapacity"},
    {label: `${i18n.t("2ndDrivePower")} (kW)`, dataIndex: "hammersNo"},
    {label: `${i18n.t("LinearSpeed")} (ft/min})`, dataIndex: "assemblyRPM", split: true},
    {label: `${i18n.t("AssemblyInstalledPower")} (kW)`, dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const cheLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: `${i18n.t("AssemblySize")} (${i18n.t("Width")} x ${i18n.t("Length")})`, dataIndex: "assemblySize"},
    {label: `${i18n.t("DesignCapacity")} (${i18n.t("TCD")})`, dataIndex: "caneCapacity"},
    {label: `${i18n.t("2ndDrivePower")} (kW)`, dataIndex: "hammersNo"},
    {label: `${i18n.t("LinearSpeed")} (ft/min)`, dataIndex: "assemblyRPM", split: true},
    {label: `${i18n.t("AssemblyInstalledPower")} (kW)`, dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const eieLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "otherInformation"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const jheLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("PumpCapacity") + " (m³/h)", dataIndex: "assemblyDesignBy"},
    {label: i18n.t("PumpSectionHead"), dataIndex: "assemblySize"},
    {label: `${i18n.t("JuiceTankCapacity")} (${i18n.t("m³")})`, dataIndex: "caneCapacity"},
    {label: `${i18n.t("RotatryScreendrivePower")} (${i18n.t("kW")})`, dataIndex: "caneCapacity"},
    {label: i18n.t("PipeSize"), dataIndex: "assemblyRPM", split: true},
    {label: i18n.t("ValvesType"), dataIndex: "assemblyRPM"},
    {label: `${i18n.t("PumpDrivePower")} (${i18n.t("kW")})`, dataIndex: "assemblyInstalledPower"},
    {label: `${i18n.t("RotatryScreenSize")}  (∅ - ${i18n.t("Length")} - ${i18n.t("SlotSize")})`, dataIndex: "colour", split: true},
    {label: `${i18n.t("DrivePower")} (${i18n.t("kW")})`, dataIndex: "assemblyManufacturedBy"},
    {label: `${i18n.t("AssemblyMakeYear")}`, dataIndex: "assemblyMakeYear", format: DATE_FORMAT_dd_MMM_YYYY},
];
const pmeLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: i18n.t("AssemblySize"), dataIndex: "assemblySize"},
    {label: `${i18n.t("DesignCapacity")} (${i18n.t("TCD")})`, dataIndex: "caneCapacity"},
    {label: `${i18n.t("DesignPower")} (${i18n.t("TCD")})`, dataIndex: "hammersNo"},
    {label: `${i18n.t("AssemblyRPM")}  (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "assemblyRPM", split: true},
    {label: `${i18n.t("AssemblyRPM")}  (${i18n.t("Input")} - ${i18n.t("Output")})`, dataIndex: "assemblyInstalledPower", split: true},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const dsbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: i18n.t("AssemblySize") , dataIndex: "assemblySize"},
    {label: `${i18n.t("DesignCapacity")} (${i18n.t("TCD")})`, dataIndex: "caneCapacity"},
    {label: `${i18n.t("DesignPower")} (${i18n.t("kW")})`, dataIndex: "hammersNo"},
    {label: `${i18n.t("AssemblyRPM")}  (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "assemblyRPM", split: true},
    {label: `${i18n.t("AssemblyRPM")}  (${i18n.t("Input")} - ${i18n.t("Output")})`, dataIndex: "assemblyInstalledPower", split: true},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const oceLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: i18n.t("AssemblySize"), dataIndex: "assemblySize"},
    {label: `${i18n.t("LiftingCapacity")}  (${i18n.t("TON")})`, dataIndex: "caneCapacity"},
    {label: `${i18n.t("LiftingSpeed")} (${i18n.t("feet / min")})`, dataIndex: "hammersNo", split: true},
    {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
    {label: `${i18n.t("RunwaySpeed")} (${i18n.t("feet / min")})`, dataIndex: "assemblyInstalledPower", split: true},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const othLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: i18n.t("AssemblySize"), dataIndex: "assemblySize"},
    {label: `${i18n.t("CaneCapacity")} TCD`, dataIndex: "caneCapacity"},
    {label: i18n.t("HammersNo"), dataIndex: "hammersNo"},
    {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
    {label: `${i18n.t("AssemblyInstalledPower")} (kW)`, dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const ahbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Type"),dataIndex: "assemblySize"},
    {label: i18n.t("HeatingSurface") + " (M²) ",dataIndex: "caneCapacity"},
    {label: i18n.t("Material"),dataIndex: "assemblyRPM"},
    {label: i18n.t("Temperature") + " (°C) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const fbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Heating Surface") + " (M²) ",dataIndex: "assemblySize"},
    {label: i18n.t("GrateArea") + " (M²) ",dataIndex: "caneCapacity"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const vbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Dimensions") + " (Duct in meters, Chimney dia in meters ) ",dataIndex: "caneCapacity"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const ebhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Type"),dataIndex: "assemblySize"},
    {label: i18n.t("HeatingSurface") + " (M²) ",dataIndex: "caneCapacity"},
    {label: i18n.t("Material"),dataIndex: "assemblyRPM"},
    {label: i18n.t("Temperature") + " (°C) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const fabhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Type"),dataIndex: "assemblySize"},
    {label: i18n.t("StaticPressure") + " (Pascals (Pa)) ",dataIndex: "caneCapacity"},
    {label: i18n.t("Capacity"),dataIndex: "assemblyRPM"},
    {label: i18n.t("InstalledPower") + " (KW) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const cbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Dimensions") + " (Chain Pitch in inches) ",dataIndex: "assemblySize"},
    {label: i18n.t("LinearSpeed") + " (Meter / Min) ",dataIndex: "caneCapacity"},
    {label: i18n.t("StandbyDrivePower") + " (KW) ",dataIndex: "hammersNo"},
    {label: i18n.t("AssemblyInstalledPower") + " (KW) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const febhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Type"),dataIndex: "assemblySize"},
    {label: i18n.t("AssemblyInstalledPower") + " (KW) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("FeederCapacity") + " (Tons /Hr) ",dataIndex: "caneCapacity"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const vbbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Configuration" + " (TPH) "),dataIndex: "assemblySize"},
    {label: i18n.t("HeatingSurface") + " (M²) ",dataIndex: "caneCapacity"},
    {label: i18n.t("Material"),dataIndex: "hammersNo"},
    {label: i18n.t("Pressure") + " (Kg/Sq.cm (Gauge)) ",dataIndex: "assemblyRPM"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const shbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("HeatingSurface")  + " (M²) ",dataIndex: "assemblySize"},
    {label: i18n.t("Temperature") + " (°C) ",dataIndex: "caneCapacity"},
    {label: i18n.t("Material"),dataIndex: "hammersNo"},
    {label: i18n.t("Type"),dataIndex: "assemblyRPM"},
    {label: i18n.t("Pressure") + " (Kg/Sq.cm (Gauge)) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const asbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Capacity"),dataIndex: "assemblySize"},
    {label: i18n.t("Quantity"),dataIndex: "caneCapacity"},
    {label: i18n.t("DraftLoss") + " (Pascals) ",dataIndex: "hammersNo"},
    {label: i18n.t("GasTemperature") + " (Celcius) ",dataIndex: "assemblyRPM"},
    {label: i18n.t("ArrestorEfficiency") + " (%) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const fwbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Type"),dataIndex: "assemblySize"},
    {label: i18n.t("Quantity"),dataIndex: "caneCapacity"},
    {label: i18n.t("Capacity" + " (Cubic meter/Hr) "),dataIndex: "hammersNo"},
    {label: i18n.t("Power") + " (KW) ",dataIndex: "assemblyRPM"},
    {label: i18n.t("Speed") + " (RPM) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("Head")+ " Meter",dataIndex: "Type"},
    {label: i18n.t("Dimensions"),dataIndex: "Colour"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const wtbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("Capacity"),dataIndex: "assemblySize"},
    {label: i18n.t("AssemblyDesignBy")  + " RO ",dataIndex: "assemblyDesignBy"},
    {label: i18n.t("PumpingPressure") + " (Pa) ",dataIndex: "caneCapacity"},
    {label: i18n.t("FlowRate") + " (Tons/Hr) ",dataIndex: "hammersNo"},
    {label: i18n.t("Type"),dataIndex: "assemblyRPM"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const sdbhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Pressure") + " (Pa) ",dataIndex: "caneCapacity"},
    {label: i18n.t("Dimensions") + " (Tons/Hr) ",dataIndex: "assemblyInstalledPower"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const etbhLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "type"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const ibhLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"),dataIndex: "assemblyName"},
    {label: i18n.t("Supply"),dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Type"),dataIndex: "assemblySize"},
    {label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`,dataIndex: "caneCapacity" , split: true},
    {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`,dataIndex: "hammersNo" , split: true},
    {label: i18n.t("Location"),dataIndex: "assemblyRPM"},
    {label: i18n.t("AssemblyManufacturedBy"),dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"),dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"),dataIndex: "assemblyInstallationYear"},
];
const msdpLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M.TON) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const usdpLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity"), dataIndex: "assemblySize" },
  { label: i18n.t("Quantity"), dataIndex: "caneCapacity" },
  { label: i18n.t("DraftLoss") + " (Pascals) ", dataIndex: "hammersNo" },
  { label: i18n.t("GasTemperature") + " (Celsius) ", dataIndex: "assemblyRPM" },
  { label: i18n.t("ArrestorEfficiency") + " (%) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const ddpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblySize" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const pdpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblySize" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const fdpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const didpLabelsAndKeys = () => [
    {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
    {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
    {label: i18n.t("Capacity" ) + " (Litre) ", dataIndex: "assemblySize"},
    {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
    {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
    {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
];
const epdpLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true },
  { label: i18n.t("Voltage") + " (V) ", dataIndex: "hammersNo" },
  { label: i18n.t("Power") + " (KVA) ", dataIndex: "assemblyRPM" },
  { label: i18n.t("Power") + " (KW) ", dataIndex: "cuttingEdge" },
  { label: i18n.t("InsulationClass") + " (IP) ", dataIndex: "otherInformation" },
  { label: i18n.t("Frequency") + " (Hz) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("Ampere") + " (I) ",  dataIndex: "type" },
  { label: i18n.t("Speed") + " (RPM) ", dataIndex: "colour" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const idpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true },
  { label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const bdbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("BiogasFlow") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Temperature") + " (°C) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const bfdbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Pressure") + " (Psi) ", dataIndex: "assemblySize" },
  { label: i18n.t("HeatingSurface") + " (M²) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Material"), dataIndex: "assemblyRPM" },
  { label: i18n.t("FlueGasesArea") + " (M²) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const fddbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("InstalledPower") + " (KW) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const sdbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Dimensions") + " (Chimney dia in meters) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Dimensions") + " (Chimney Height in meters) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const epdbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true },
  { label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const idbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity" , split: true },
  { label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const wtdbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("PumpingPressure") + " (Psi)", dataIndex: "caneCapacity" },
  { label: i18n.t("Flow") + " (M³)", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const fpdbLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Capacity") + " (M³)", dataIndex: "caneCapacity" },
  { label: i18n.t("Speed") + " (RPM)", dataIndex: "assemblyRPM" },
  { label: i18n.t("Power") + " (KW)", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("Head") + " (M)", dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" }
];
const cpetpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Volume") + " (M³)", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const fsetpLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const adetpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³)", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const bretpLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const doetpLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const tphLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("HeatingSurface")  + " (M²) ", dataIndex: "assemblySize" },
  { label: i18n.t("Temperature") + " (°C) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Material"), dataIndex: "hammersNo" },
  { label: i18n.t("Type"), dataIndex: "assemblyRPM" },
  { label: i18n.t("Pressure") + " (Kg/Sq.cm (Gauge)) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const gphLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("HeatingSurface")  + " (M²) ", dataIndex: "assemblySize" },
  { label: i18n.t("Temperature") + " (°C) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Material"), dataIndex: "hammersNo" },
  { label: i18n.t("Type"), dataIndex: "assemblyRPM" },
  { label: i18n.t("Pressure") + " (Kg/Sq.cm (Gauge)) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const dphLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Power")  + " (KW) ", dataIndex: "assemblySize" },
  { label: i18n.t("GeneratorWindingTemperature") + " (°C) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Type"), dataIndex: "assemblyRPM" },
  { label: i18n.t("Speed") + " (RPM) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const ohphLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("HeatingSurface")  + " (M²) ", dataIndex: "assemblySize" },
  { label: i18n.t("Temperature") + " (°C) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Material"), dataIndex: "hammersNo" },
  { label: i18n.t("Type"), dataIndex: "assemblyRPM" },
  { label: i18n.t("Pressure") + " (Kg/Sq.cm (Gauge)) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const eephLablesAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "type"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const icphLablesAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true },
  { label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo" },
  { label: i18n.t("Location"), dataIndex: "assemblyRPM" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const cclLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const cdclLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("QuntityOfTanks"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("noOfPumps"), dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const dclLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Type"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const eclLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity/HeatingSurface") + " (M²) ", dataIndex: "assemblySize" },
  { label: i18n.t("Manufacturer/type"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const eeclLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "type"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const fclLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Design/TYPE"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const iclLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Supply"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("SafetyTrippingDescription"), dataIndex: "colour"},
  {label: i18n.t("Location"), dataIndex: "assemblyRPM"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const jhclLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("HeatingSurface") + " (M²) ", dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const lsclLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Quantity"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const stclLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("QuntityOfTanks"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity"},
  {label: i18n.t("noOfPumps"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const ccrLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity"},
  {label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const cocrLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Design/TYPE"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const ctcrLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("noOffan"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const ctphLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];

const eecrLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "type"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const icrLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Supply"), dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("SafetyTrippingDescription"), dataIndex: "colour"},
  {label: i18n.t("Location"), dataIndex: "assemblyRPM"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"}
];
const iscrLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Type"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("Head"), dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM" },
  // { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  // { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const pcrLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" },
  //{ label: i18n.t("AssemblyProfileImage"), dataIndex: "imageFile" }
];
const stcrLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Design/TYPE"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("noOfPumps"), dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const trcrLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const eectLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "type"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const icctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true },
  { label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true },
  { label: i18n.t("SafetyTrippingDescription"), dataIndex: "colour" },
  { label: i18n.t("Location"), dataIndex: "assemblyRPM" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const mmctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const mtctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("noOffan"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const pctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const rcctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const rctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Design/TYPE"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("noOfPumps"), dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const rfctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const rtctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("noOfPumps"), dataIndex: "hammersNo" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const scctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const vcctLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const bcbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Bags/Min) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const dbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const dcbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const eebaLabelsAndKeys = () => [
  {label: i18n.t("AssemblyName"), dataIndex: "assemblyName"},
  {label: i18n.t("Type"), dataIndex: "assemblySize"},
  {label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy"},
  {label: i18n.t("RatedPower") + " (KW/KVA) ", dataIndex: "colour"},
  {label: i18n.t("Voltage") + " (V) ", dataIndex: "assemblyDesignBy"},
  {label: i18n.t("Current"), dataIndex: "assemblyInstalledPower"},
  {label: i18n.t("AssemblyRPM"), dataIndex: "assemblyRPM"},
  {label: i18n.t("DrivenMethod"), dataIndex: "type"},
  {label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear"},
  {label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true},
  {label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear"},
  {label: i18n.t("Location"), dataIndex: "caneCapacity"},
];
const gbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const hbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const icbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("Supply"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Type"), dataIndex: "assemblySize" },
  { label: i18n.t("Range") + ` (${i18n.t("Min")} - ${i18n.t("Max")})`, dataIndex: "caneCapacity", split: true },
  { label: i18n.t("SafetyTripping") + ` (${i18n.t("Yes")} - ${i18n.t("No")})`, dataIndex: "hammersNo", split: true },
  { label: i18n.t("SafetyTrippingDescription"), dataIndex: "colour" },
  { label: i18n.t("Location"), dataIndex: "assemblyRPM" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const rbbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const sbbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons) ", dataIndex: "caneCapacity" },
  { label: i18n.t("Quantity"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const sebaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Tons/Hr) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const ssbaLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (Bags/Min) ", dataIndex: "caneCapacity" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const evapLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const yrpLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const fppLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const esdLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
const wsfsLabelsAndKeys = () => [
  { label: i18n.t("AssemblyName"), dataIndex: "assemblyName" },
  { label: i18n.t("AssemblyDesignBy"), dataIndex: "assemblyDesignBy" },
  { label: i18n.t("Capacity") + " (M³) ", dataIndex: "assemblyInstalledPower" },
  { label: i18n.t("AssemblyManufacturedBy"), dataIndex: "assemblyManufacturedBy" },
  { label: i18n.t("AssemblyMakeYear"), dataIndex: "assemblyMakeYear" },
  { label: i18n.t("AssemblyInstallationYear"), dataIndex: "assemblyInstallationYear" }
];
export const getAssemblyLabelsAndData = (section) =>{
    switch (section) {
        case "CME": return cmeLabelsAndKeys();
        case "CPE": return cpeLabelsAndKeys();
        case "CCE": return cceLabelsAndKeys();
        case "CHE": return cheLabelsAndKeys();
        case "EIE": return eieLabelsAndKeys();
        case "JHE": return jheLabelsAndKeys();
        case "PME": return pmeLabelsAndKeys();
        case "OCE": return oceLabelsAndKeys();
        case "OTH": return othLabelsAndKeys();
        case "FBH": return fbhLabelsAndKeys();
        case "VBBH": return vbbhLabelsAndKeys();
        case "AHBH": return ahbhLabelsAndKeys();
        case "EBH": return ebhLabelsAndKeys();
        case "FABH": return fabhLabelsAndKeys();
        case "CBH": return cbhLabelsAndKeys();
        case "FEBH": return febhLabelsAndKeys();
        case "VBH": return vbhLabelsAndKeys();
        case "ETBH": return etbhLabelsAndKeys();
        case "IBH": return ibhLabelsAndKeys();
        case "FWBH": return fwbhLabelsAndKeys();
        case "SDBH": return sdbhLabelsAndKeys();
        case "WTBH": return wtbhLabelsAndKeys();
        case "ASBH": return asbhLabelsAndKeys();
        case "SHBH": return shbhLabelsAndKeys();
        case "MSDP" : return msdpLablesAndKeys();
        case "USDP" : return usdpLablesAndKeys();
        case "DDP" : return ddpLabelsAndKeys();
        case "PDP" : return pdpLabelsAndKeys();
        case "FDP" : return fdpLabelsAndKeys();
        case "DIDP" : return didpLabelsAndKeys();
        case "EPDP" : return epdpLablesAndKeys();
        case "IDP" : return idpLabelsAndKeys();
        case "BDB" : return bdbLabelsAndKeys();
        case "BFDB" : return bfdbLabelsAndKeys();
        case "FDDB" : return fddbLabelsAndKeys();
        case "SDB" : return sdbLabelsAndKeys();
        case "EPDB" : return epdbLabelsAndKeys();
        case "IDB" : return idbLabelsAndKeys();
        case "WTDB" : return wtdbLabelsAndKeys();
        case "FPDB" : return fpdbLabelsAndKeys();
        case "CPETP" : return cpetpLabelsAndKeys();
        case "FSETP" : return fsetpLablesAndKeys();
        case "ADETP" : return adetpLabelsAndKeys();
        case "BRETP" : return bretpLablesAndKeys();
        case "DOETP" : return doetpLablesAndKeys();
        case "TPH" : return tphLablesAndKeys();
        case "GPH" : return gphLablesAndKeys();
        case "OHPH" : return ohphLablesAndKeys();
        case "EEPH" : return eephLablesAndKeys();
        case "ICPH" : return icphLablesAndKeys();
        case "CCL" : return cclLabelsAndKeys();
        case "CDCL" : return cdclLabelsAndKeys();
        case "DCL" : return dclLabelsAndKeys();
        case "ECL" : return eclLabelsAndKeys();
        case "EECL" : return eeclLabelsAndKeys();
        case "FCL" : return fclLabelsAndKeys();
        case "ICL" : return iclLabelsAndKeys();
        case "JHCL" : return jhclLabelsAndKeys();
        case "LSCL" : return lsclLabelsAndKeys();
        case "STCL" : return stclLabelsAndKeys();
        case "CCR" : return ccrLabelsAndKeys();
        case "COCR" : return cocrLabelsAndKeys();
        case "CTCR" : return ctcrLabelsAndKeys();
        case "EECR" : return eecrLabelsAndKeys();
        case "ICR" : return icrLabelsAndKeys();
        case "ISCR" : return iscrLabelsAndKeys();
        case "PCR" : return pcrLabelsAndKeys();
        case "STCR" : return stcrLabelsAndKeys();
        case "TRCR" : return trcrLabelsAndKeys();
        case "EECT" : return eectLabelsAndKeys();
        case "ICCT" : return icctLabelsAndKeys();
        case "MMCT" : return mmctLabelsAndKeys();
        case "MTCT" : return mtctLabelsAndKeys();
        case "PCT" : return pctLabelsAndKeys();
        case "RCCT" : return rcctLabelsAndKeys();
        case "RCT" : return rctLabelsAndKeys();
        case "RFCT" : return rfctLabelsAndKeys();
        case "RTCT" : return rtctLabelsAndKeys();
        case "SCCT" : return scctLabelsAndKeys();
        case "VCCT" : return vcctLabelsAndKeys();
        case "BCBA" : return bcbaLabelsAndKeys();
        case "DBA" : return dbaLabelsAndKeys();
        case "DCBA" : return dcbaLabelsAndKeys();
        case "EEBA" : return eebaLabelsAndKeys();
        case "GBA" : return gbaLabelsAndKeys();
        case "HBA" : return hbaLabelsAndKeys();
        case "ICBA" : return icbaLabelsAndKeys();
        case "RBBA" : return rbbaLabelsAndKeys();
        case "SBBA" : return sbbaLabelsAndKeys();
        case "SEBA" : return sebaLabelsAndKeys();
        case "SSBA" : return ssbaLabelsAndKeys();
        case "DPH" : return dphLablesAndKeys();
        case "CTPH" : return ctphLabelsAndKeys();
         case "DSBH": return dsbhLabelsAndKeys();
        case "EVAP": return evapLabelsAndKeys();
        case "YRP": return yrpLabelsAndKeys();
        case "FPP": return fppLabelsAndKeys();
         case "ESD": return esdLabelsAndKeys();
        case "WSFS": return wsfsLabelsAndKeys();
        default: return cpeLabelsAndKeys();
    }
}